const kidsList = [
  'Want someday',
  "Don't want",
  'Have & want more',
  "Have & don't want more",
];

const languageList = [
  'English',
  'Mandarin',
  'Hindi',
  'Spanish',
  'French',
  'Standard Arabic',
  'Bengali',
  'Russian',
  'Portuguese',
  'Indonesian',
  'Urdu',
  'Standard German',
  'Japanese',
  'Swahili',
  'Marathi',
  'Telugu',
  'Western Punjabi',
  'Wu Chinese',
  'Tamil',
  'Turkish',
  'Thai',
  'Other',
];

const drinkingList = ['Never', 'Socially', 'Sometimes', 'Often', 'Quitting'];

const cityList = [
  'Vancouver',
  'Burnaby',
  'Richmond',
  'North Vancouver',
  'West Vancouver',
  'Abbotsford',
  'Surrey',
  'Delta',
  'Langley',
  'Coquitlam',
  'Victoria',
  'Nanaimo',
  'Whistler',
  'Chilliwack',
  'Kelowna',
  'Kamloops',
  'Calgary',
  'Edmonton',
  'Saskatoon',
  'Regina',
  'Winnipeg',
  'Toronto',
  'Ottawa',
  'Montreal',
  'Mississauga',
  'London',
  'Richmond Hill',
  'Montreal',
];

const religionList = [
  'Agnostic',
  'Atheist',
  'Buddhist',
  'Catholic',
  'Christian',
  'Hindu',
  'Jewish',
  'Muslim',
  'Sikh',
  'Spiritual',
  'Taoism',
  'Other/None',
];

const educationList = [
  'High school',
  'Trad/Tech school',
  'Bachelor degree',
  'Master degree',
  'Doctorate',
  'Other',
];

const maritalList = ['Single', 'Divorced', 'Widowed', 'Separated'];

const zodiacList = [
  'Aquarius',
  'Pisces',
  'Aries',
  'Taurus',
  'Gemini',
  'Cancer',
  'Leo',
  'Virgo',
  'Libra',
  'Scorpio',
  'Sagittarius',
  'Capricorn',
];
const petsList = ['Dog(s)', 'Cat(s)', 'None', "Don't want", 'Other(s)'];

const smokingList = ['Never', 'Socially', 'Sometimes', 'Often', 'Quitting'];

const excerciseList = ['Active', 'Sometimes', 'Almost never'];

export const initalMetas = [
  {
    question: {
      name: 'Bio',
      description: 'Your bio...',
      id: 'bio',
      type: 'textarea',
      group: 'bio',
      hint: 'Write something about you...',
    },
    answer: ['I’m GM. I’m doing Becase Test.'],
  },
  {
    question: {
      name: 'Religion',
      id: 'religion',
      type: 'radio',
      group: 'optional2',
      values: religionList,
      hint: 'Select',
    },
    answer: ['Other/None'],
  },
  {
    question: {
      name: 'Height',
      id: 'height',
      type: 'height',
      group: 'optional2',
      hint: 'Select',
    },
    answer: ['174cm'],
  },
  {
    question: {
      name: 'Education',
      id: 'education',
      type: 'radio',
      group: 'optional2',
      values: educationList,
      hint: 'Select',
    },
    answer: ['Bachelor degree'],
  },
  {
    question: {
      name: 'Marital',
      id: 'marital',
      type: 'radio',
      group: 'optional2',
      values: maritalList,
      hint: 'Select',
    },
    answer: ['Single'],
  },
  {
    question: {
      name: 'Zodiac',
      id: 'zodiac',
      type: 'radio-icon',
      group: 'optional2',
      values: zodiacList,
      hint: 'Select',
    },
    answer: [zodiacList[Math.floor(Math.random() * zodiacList.length)]],
  },
  {
    question: {
      name: 'Excercise',
      id: 'excercise',
      type: 'radio',
      group: 'optional3',
      values: excerciseList,
      hint: 'Select',
    },
    answer: [excerciseList[Math.floor(Math.random() * excerciseList.length)]],
  },
  {
    question: {
      name: 'Smoking',
      id: 'smoking',
      type: 'radio',
      group: 'optional3',
      values: smokingList,
      hint: 'Select',
    },
    answer: ['Never'],
  },
  {
    question: {
      name: 'Pets',
      id: 'pets',
      type: 'radio',
      group: 'optional3',
      values: petsList,
      hint: 'Select',
    },
    answer: [petsList[Math.floor(Math.random() * petsList.length)]],
  },
  {
    question: {
      name: 'Drinking',
      id: 'drinking',
      type: 'radio',
      group: 'optional3',
      values: drinkingList,
      hint: 'Select',
    },
    answer: ['Socially'],
  },
  {
    question: {
      name: 'Kids',
      id: 'kids',
      type: 'radio',
      group: 'optional3',
      values: kidsList,
      hint: 'Select',
    },
    answer: ['Want someday'],
  },
  {
    question: {
      name: 'Language',
      id: 'language',
      type: 'checkbox',
      group: 'optional1',
      values: languageList,
      hint: 'Select',
    },
    answer: ['Mandarin', 'English'],
  },
  {
    question: {
      name: 'Career',
      id: 'career',
      type: 'textfield',
      group: 'optional1',
      hint: 'Tap to enter',
    },
    answer: [],
  },
  {
    question: {
      name: 'From',
      description: 'You from...',
      id: 'from',
      type: 'location',
      group: 'geo',
      hint: 'Select',
    },
    answer: ['Beijing', 'China'],
  },
  {
    question: {
      name: 'Live in',
      description: 'Living in...',
      id: 'livingIn',
      type: 'location',
      group: 'geo',
      hint: 'Select',
    },
    answer: [cityList[Math.floor(Math.random() * cityList.length)], 'Canada'],
  },
];
